import { listListingVariantFetchParamsForChannel } from './resolveListingVariantFetchParams';

const refreshListingVariantAssetsForChannel = async ({
  dispatch,
  fetchVariantAssets,
  productId,
  productsState,
  channelId,
}) => {
  const variantParams = listListingVariantFetchParamsForChannel(productsState, channelId);
  if (!variantParams.length) return;

  await Promise.all(variantParams.map(({
    linkVariantId,
    masterVariantId,
  }) => dispatch(fetchVariantAssets({
    productId,
    variantId: linkVariantId,
    channelId,
    masterVariantId,
  }))));
};

export default refreshListingVariantAssetsForChannel;
